import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { BaseApiResponse } from '../../models/api/api.model';
import { User } from '../../models/user/user.model';
import { environment } from '../../../../environments/environment';
import { GetLanguageForUserModel } from '../../models/user/get-language-for-user.model';
import { GetUsersByRole } from '../../models/user/get-users-by-role.model';
import { UserByPatientResponse } from '../../models/user/user-by-patient.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apiService: ApiService) {}

  deleteUnit(id: string, url: string): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      this.apiService
        .delete(environment.apiLocations.identity + url + id)
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }

  getUserById(id: string): Observable<BaseApiResponse<User>> {
    return new Observable((observer) => {
      this.apiService
        .get(environment.apiLocations.identity + '/users/' + id)
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }

  addUser(
    formData: FormData,
    type: string,
    id?: string
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      if (type == 'PUT') {
        this.apiService
          .put(environment.apiLocations.identity + '/users/' + id, formData)
          .subscribe((res: any) => {
            observer.next(res);
            observer.complete();
          });
      } else {
        this.apiService
          .post(environment.apiLocations.identity + '/users', formData)
          .subscribe((res: any) => {
            observer.next(res);
            observer.complete();
          });
      }
    });
  }

  getRoles(isEdit: boolean = false): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      this.apiService
        .get(
          environment.apiLocations.identity +
            '/Roles/get-all-role?IsEdit=' +
            isEdit
        )
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }

  addUserDepartment(
    userId: string,
    payload: any
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      this.apiService
        .post(
          environment.apiLocations.identity + '/user-departments/' + userId,
          payload
        )
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }

  getListUserByDepartment(
    departmentId: string
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      this.apiService
        .get(
          environment.apiLocations.identity +
            '/user-departments/' +
            departmentId +
            '/users'
        )
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }

  switchUserStatus(
    id: string,
    status: number
  ): Observable<BaseApiResponse<any>> {
    return new Observable((observer) => {
      let payload = {
        userId: id,
        userStatus: status,
      };
      this.apiService
        .put(environment.apiLocations.identity + '/Users/status/' + id, payload)
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }

  getLanguageForUser(): Observable<BaseApiResponse<GetLanguageForUserModel>> {
    return this.apiService.get<GetLanguageForUserModel>(
      environment.apiLocations.identity + '/Users/get-language-for-user'
    );
  }

  getUsersByRole(
    roleName: string,
    pageIndex: number,
    pageSize: number,
    nurseName?: string | null
  ): Observable<BaseApiResponse<GetUsersByRole[]>> {
    let url =
      `${environment.apiLocations.identity}/Users/get-users-by-role` +
      `?pageIndex=${pageIndex}` +
      `&pageSize=${pageSize}` +
      `&roleName=${roleName}`;

    if (nurseName && nurseName.trim() !== '') {
      url += `&nurseName=${encodeURIComponent(nurseName)}`;
    }

    return this.apiService.get<GetUsersByRole[]>(url);
  }

  getUserByPatientId(
    patientId: string
  ): Observable<BaseApiResponse<UserByPatientResponse>> {
    const url =
      environment.apiLocations.identity + '/users/by-patient/' + patientId;
    return this.apiService.get<UserByPatientResponse>(url);
  }

  isManagerPresentInDepartment(
    organizationId?: string | null,
    departmentId?: string | null,
    facilityId?: string | null
  ): Observable<BaseApiResponse<any>> {
    let query = '';

    const appendParam = (key: string, value: string) => {
      query += (query === '' ? '?' : '&') + `${key}=${value}`;
    };

    if (organizationId && organizationId !== 'null') {
      appendParam('organizationId', organizationId);
    }

    if (departmentId && departmentId !== 'null') {
      appendParam('departmentId', departmentId);
    }

    if (facilityId && facilityId !== 'null') {
      appendParam('facilityId', facilityId);
    }

    return new Observable((observer) => {
      this.apiService
        .get(
          `${environment.apiLocations.identity}/user-departments/is-manager-present-in-department${query}`
        )
        .subscribe((res: any) => {
          observer.next(res);
          observer.complete();
        });
    });
  }
}
